import { useContext } from "react";
import ToastContext from "../../config/context/toastContext";
import styles from "../../css/toast.module.css";
import Toast from "./Toast";

// Crta se na JEDNOM mestu, u `App.jsx`. Ranije je stajala i u dva ekrana za
// plugine, a pošto sve tri čitaju istu listu, na tim ekranima bi se svaka
// poruka pojavila tri puta.
const ToastList = () => {
  const { toastList, removeToast } = useContext(ToastContext);

  if (toastList.length === 0) return null;

  return (
    <div className={styles.toastContainer}>
      {toastList.map((toast) => (
        <Toast key={toast.id} {...toast} removeToast={removeToast} />
      ))}
    </div>
  );
};

export default ToastList;
